import { z } from "zod";
const dbBand = z.number().min(-24).max(24);
export const masterEqAdjustedPayloadSchema = z.object({
    lowDb: dbBand,
    midDb: dbBand,
    highDb: dbBand,
});
//# sourceMappingURL=mix.js.map